import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterUseTypeList as getWaterUseTypeListApi,
	getWaterUseTypeListQuery as getWaterUseTypeListQueryApi,
	getWaterUseType as getWaterUseTypeApi,
	addNewWaterUseTypeApi,
	updateWaterUseTypeApi,
	deleteWaterUseTypeApi,
	checkWaterUseTypeExistsApi,
} from '../../helpers/water_use_type/api_helper';

export const getWaterUseTypeList = createAsyncThunk(
	'waterUseType/getWaterUseTypeList',
	async () => {
		try {
			const response = await getWaterUseTypeListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los tipos de uso de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterUseTypeListQuery = createAsyncThunk(
	'waterUseType/getWaterUseTypeListQuery',
	async params => {
		try {
			const response = getWaterUseTypeListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterUseType = createAsyncThunk(
	'waterUseType/getWaterUseType',
	async water_use_type_id => {
		try {
			const response = await getWaterUseTypeApi(water_use_type_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el tipo de uso de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterUseType = createAsyncThunk(
	'waterUseType/addNewWaterUseType',
	async water_use_type => {
		try {
			const response = await addNewWaterUseTypeApi(water_use_type);
			toast.success('Tipo de Uso de Agua agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el tipo de uso de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterUseType = createAsyncThunk(
	'waterUseType/updateWaterUseType',
	async water_use_type => {
		try {
			const response = await updateWaterUseTypeApi(water_use_type);
			toast.success('Tipo de Uso de Agua actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el tipo de uso de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterUseType = createAsyncThunk(
	'waterUseType/deleteWaterUseType',
	async water_use_type => {
		try {
			const response = await deleteWaterUseTypeApi(water_use_type._id);
			toast.success('Tipo de Uso de Agua eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_use_type;
		} catch (error) {
			toast.error('Error al eliminar el tipo de uso de agua.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterUseTypeExists = createAsyncThunk(
	'waterUseType/checkWaterUseTypeExists',
	async name => {
		try {
			const response = await checkWaterUseTypeExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
